var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerAssetMutedHasDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_11600)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14829_11600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.678955 17.1594C0.678955 7.85937 8.17895 0.359375 17.479 0.359375C26.779 0.359375 34.279 7.85937 34.279 17.1594C34.279 26.4594 26.779 33.9594 17.479 33.9594C8.17895 33.9594 0.678955 26.4594 0.678955 17.1594Z",
    fill: "#354052",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2789 7.55937C23.0789 5.45937 20.3789 4.35938 17.4789 4.35938C14.4789 4.35938 11.8789 5.45937 9.67893 7.55937C7.37893 9.65937 6.27893 12.4594 6.27893 15.6594C6.27893 18.0594 7.17893 20.5594 8.87893 23.0594C10.4789 25.3594 12.8789 27.8594 16.1789 30.5594L17.4789 31.6594L18.7789 30.5594C21.9789 27.8594 24.4789 25.3594 26.0789 23.0594C27.7789 20.5594 28.6789 18.0594 28.6789 15.6594C28.5789 12.4594 27.4789 9.65937 25.2789 7.55937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4789 21.9594C22.9789 24.1594 20.6789 26.4594 17.5789 29.0594C14.4789 26.4594 12.1789 24.1594 10.6789 21.9594C9.17891 19.7594 8.37891 17.6594 8.37891 15.6594C8.37891 12.9594 9.27891 10.6594 11.0789 8.95938C12.8789 7.25938 15.0789 6.35938 17.5789 6.35938C20.0789 6.35938 22.1789 7.25938 23.9789 8.95938C25.7789 10.6594 26.6789 12.9594 26.6789 15.6594C26.6789 17.6594 25.9789 19.7594 24.4789 21.9594Z",
    fill: "#354052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.479 17.5586C17.979 17.5586 18.479 17.3586 18.879 16.9586C19.279 16.5586 19.479 16.1586 19.479 15.5586C19.479 15.0586 19.279 14.5586 18.879 14.1586C18.479 13.7586 18.079 13.5586 17.479 13.5586C16.979 13.5586 16.479 13.7586 16.079 14.1586C15.679 14.5586 15.479 15.0586 15.479 15.5586C15.479 16.0586 15.679 16.5586 16.079 16.9586C16.479 17.3586 16.879 17.5586 17.479 17.5586Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_11600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.679,
    height: 33.679,
    fill: "white",
    transform: "translate(0.678955 0.359375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14829_11600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.7,
    height: 33.7,
    fill: "white",
    transform: "translate(0.678955 0.359375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerAssetMutedHasDevice);
export default __webpack_public_path__ + "static/media/marker_asset_muted_has_device.be91fe3d98f2f43ea28b02d8b301c62d.svg";
export { ForwardRef as ReactComponent };